import { Attr, Meta } from '@anny.co/vue-jsonapi-orm'
import { ApiResource } from '../ApiResource'

export type ResourceGroupSettings = {
  maxBookings: {
    perDay: null | number
    perWeek: null | number
    perMonth: null | number
    perSlot: null | number
  }
}

export class ResourceGroup extends ApiResource {
  static jsonApiType = 'resource-groups'
  @Attr() name: string
  @Attr({}) localNameI18n?: Record<string, string> | null
  @Attr({
    maxBookings: {
      perDay: null,
      perWeek: null,
      perMonth: null,
      perSlot: null,
    },
  } as ResourceGroupSettings)
  settings: Record<string, any>
  @Meta() resourcesCount: number | null
}
